const common = require("lib/labels/_common");

module.exports = {
  login: require("./login"),
  connecting: {
    en: "Connecting",
    fr: "Connexion en cours"
  },
  signup: {
    title: {
      en: "Register",
      fr: "Inscription"
    },
    firstName: {
      en: "Firstname",
      fr: "Prénom"
    },
    lastName: {
      en: "Lastname",
      fr: "Nom"
    },
    groupUid: {
      en: "group",
      fr: "Groupe"
    },
    login: common.email,
    phone: {
      en: "Phone",
      fr: "Téléphone"
    },
    mobile: {
      en: "Mobile",
      fr: "Mobile"
    },
    submit: {
      en: "Register",
      fr: "S'inscrire"
    },
    errInvalid: {
      en: "Invalid email",
      fr: "L'email est invalide"
    },
    internal: {
      en: "Internal error",
      fr: "Erreur interne"
    },
    errExists: {
      en: "Email already exists",
      fr: "Cet email existe déjà"
    },
    titleSuccess:{
      en: "Your request has been transmited to your group's administrators",
      fr: "Votre demande a bien été transmise aux administrateurs de votre groupe"
    },
    textSuccess:{
      en: "An administrator will validate your request. Please check your mail account.",
      fr: "Un administrateur va valider votre demande dans les plus brefs delais. Une fois cela fait vous pourrez créer un mot de passe via reception d'un mail de notre part."
    }
  },
  contact: {
    title: {
      en: "Contact",
      fr: "Contact"
    },
    name: common.name,
    email: common.email,
    company: common.company,
    subject: {
      en: "Subject",
      fr: "Objet"
    },
    message: common.message,
    submit: common.send
  },
  presentation: {
    slide1: {
      en: "Welcome",
      fr: "Bienvenue"
    },
    slide2: {
      en: "Discover SimTopy",
      fr: "Découvrez SimTopy"
    },
    services: {
      title: {
        en: "Our services",
        fr: "Nos services"
      }
    }
  },
  footer: {
    contact: {
      title: {
        en: "Contact Information",
        fr: "Coordonnées"
      }
    }
  }
};
